/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDivert = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m11.49 2.211 3.64 3.82-3.64 3.818-1.387-1.457L11.429 7H4v4h14.27l-1.297-1.362 1.388-1.457L22 12l-3.639 3.819-1.388-1.457L18.27 13H4v4h7.429l-1.326-1.392 1.388-1.457 3.638 3.819-3.638 3.819-1.388-1.457 1.268-1.333L2 19V5h9.371l-1.268-1.332z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgDivert as Divert };
